import { createUseDataTrackEventProps } from './create-hooks'

// 节点进入可视区域上报节点属性
export const dataTrackViewElementName = 'data-track-view-ele'

export const useDataTrackViewEventProps = createUseDataTrackEventProps(
  dataTrackViewElementName,
)
